// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "o2/opus2." + chunkId + "." + {"redirect-guard":"71578c61fdc92a1072a0","monitor-modules":"ad533cc86e95a01bcc08","textToSpeech":"3f30bf5e2cb4964a1b4e","testimonial-vdom":"4dcf0e30864192fa1d55","testimonial-rocket":"cfc0a6a3ba83329e2064"}[chunkId] + ".js";
};